import { render, staticRenderFns } from "./CsTableHead.vue?vue&type=template&id=bca8b4e8&"
import script from "./CsTableHead.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsTableHead.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports